<template>
    <div class="columns is-mobile is-centered has-background-primary p-2" v-if="props.titoloVisibile==true">
        <h1 class="title is-4 has-text-white">LAVORI</h1>
    </div>

        <div class="columns is-mobile is-centered">

        <div class="column is-6" v-if="props.campoRicercaVisibile==true">
            <div class="field has-addons">
                <div class="control is-expanded">
                    <input class="input is-primary" type="text" v-model="testoRicerca" placeholder="Cerca..." @keyup.enter="bCerca(['codice', 'oggetto', 'stato', 'fase'])">
                </div>
                <div class="control">
                    <button class="button is-primary" @click="bCerca(['JSON'])">
                        <p><i class="fas fa-eye"></i></p>
                    </button>
                </div>
            </div>
        </div>
        <div class="column is-1 has-text-centered" v-if="props.bottoneAggiungiVisibile==true && !schermoLargo">
            <button class="button is-primary is-outlined" @click="bSelezionaLavoro(-1, null)">
                <span class="icon"><i class="fas fa-plus"></i></span>
            </button>
        </div>
        <div class="column is-1 has-text-right" v-if="props.campoRicercaVisibile==true && schermoLargo">
            <button class="button is-primary is-outlined" title="Mostra grafici" @click="bMostraGrafici()">
                <span class="icon"><i class="fas fa-chart-line"></i></span>
            </button>
        </div>
        <div class="column is-1 has-text-left" v-if="props.campoRicercaVisibile==true">
            <button class="button is-primary is-outlined" title="Mostra mappa" @click="bMostraMappa()">
                <span class="icon"><i class="fas fa-map-marked-alt"></i></span>
            </button>
        </div>
    </div>

    <div class="blocco-scroll" v-if="!schermoLargo && !bottoneAnnullaVisibile">
        <div class="box" v-for="(ll) in elencoLavori" :key="leggiInfoDB(ll).id">
            <button class="button is-small is-primary is-outlined" @click="bSelezionaLavoro(leggiInfoDB(ll).id, leggiInfoDB(ll).idCliente)">
                <span class="icon"><i class="fas fa-arrow-right-from-bracket"></i></span>
            </button>
            &nbsp; &nbsp; {{(ll.codice)?codiceCifreFisse(ll.codice,2):''}}
            <div v-if="props.cliente==null"> <a @click="emit('elementoSelezionato', {tipo: 'cliente', idCliente: leggiInfoDB(ll).idCliente})">{{leggiInfoDB(ll).stringaCliente}}</a> </div>
            <div v-if="ll.oggetto"> {{ll.oggetto}} </div>
            <div v-if="ll.dataOrdine"> Data ordine: {{dataDaTimestamp(ll.dataOrdine, 'testo')}} </div>
        </div>
        <div>
            &nbsp;  &nbsp; &nbsp; &nbsp; {{stringaNumeroRecord}}
        </div>
        <div>&nbsp;</div>
    </div>

    <div class="blocco-scroll" v-if="schermoLargo">
        <table class="table is-striped mx-auto">
            <thead>
                <tr>
                    <th class="has-text-centered">
                        <button class="button is-small is-primary is-outlined" @click="bSelezionaLavoro(-1, null)" v-if="props.bottoneAggiungiVisibile==true">
                            <span class="icon"><i class="fas fa-plus"></i></span>
                        </button>
                    </th>
                    <th v-if="mostraInfoSviluppo"></th>
                    <th class="has-text-centered" v-if="mostraInfoSviluppo">Id</th>
                    <th v-if="bottoneAnnullaVisibile">Lavori</th>
                    <th class="has-text-centered" v-if="!bottoneAnnullaVisibile">Codice</th>
                    <th v-if="props.cliente==null && !bottoneAnnullaVisibile">Cliente</th>
                    <th v-if="!bottoneAnnullaVisibile">Oggetto</th>
                    <th v-if="!bottoneAnnullaVisibile">Ordine</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(ll, index) in elencoLavori" :key="leggiInfoDB(ll).id">
                    <td class="has-text-centered">
                        <button class="button is-small is-primary is-outlined" @click="bSelezionaLavoro(leggiInfoDB(ll).id, leggiInfoDB(ll).idCliente)">
                            <span class="icon"><i class="fas fa-arrow-right-from-bracket"></i></span>
                        </button>
                    </td>
                    <td class="has-text-centered" v-if="mostraInfoSviluppo">{{index + 1}}</td>
                    <td class="has-text-centered" v-if="mostraInfoSviluppo">{{leggiInfoDB(ll).id}}</td>
                    <td v-if="bottoneAnnullaVisibile">{{leggiInfoDB(ll).stringaLavoro}}</td>
                    <td class="has-text-centered" v-if="!bottoneAnnullaVisibile">{{(ll.codice)?codiceCifreFisse(ll.codice,2):''}}</td>
                    <td v-if="props.cliente==null && !bottoneAnnullaVisibile"><a @click="emit('elementoSelezionato', {tipo: 'cliente', idCliente: leggiInfoDB(ll).idCliente})">{{leggiInfoDB(ll).stringaCliente}}</a></td>
                    <td v-if="!bottoneAnnullaVisibile">{{ll.oggetto}}</td>
                    <td v-if="!bottoneAnnullaVisibile">{{dataDaTimestamp(ll.dataOrdine, 'testo')}}</td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <td class="has-text-centered" colspan="2">{{stringaNumeroRecord}}</td>
                </tr>
            </tfoot>
        </table>
    </div>

    <GraficoVendite
        :datiGrafico="datiGraficoLavori"
        @selezionato="bComandoModale"
        v-if="mostraGraficoLavori"
    />
    <MappaPin 
        v-if="vistaMappa"
        titoloMappa="Mappa Lavori"
        :datiMappa="datiMappaLavori"
        @selezionato="bComandoModale"
        @elementoSelezionato="(el) => emit('elementoSelezionato', el)"
    />

</template>

<script setup>
    import MappaPin from './MappaPin.vue';
    import GraficoVendite from './GraficoVendite.vue';
    import { defineProps, defineEmits, computed, ref } from "vue";
    import { dataDaTimestamp, codiceCifreFisse, mostraInfoSviluppo, schermoLargo, getValorePerOrdinamento } from "./../code/utilita";
    import { dbClienti, dbContatti, leggiInfoDB, leggiInfoDBRaw } from "@/code/gestioneDB";

    // PROPRIETA' ED EVENTI DEL COMPONENTE
    const props = defineProps({
        cliente: {
            type: Number,
            default: null },
        testoDaCercare: {
            type: String,
            default: null },
        campiDaCercare: {
            type: Array,
            default:  () => {return ['tipo','oggetto']}
        },
        bottoneAnnullaVisibile: {
            type: Boolean,
            default: false },
        bottoneAggiungiVisibile: {
            type: Boolean,
            default: false },
        campoRicercaVisibile: {
            type: Boolean,
            default: true },
        elencoTassativo: {
            type: Object,
            default: () => {return null}
        },
        titoloVisibile: {
            type: Boolean,
            default: true }
    });
    const emit = defineEmits(['elementoSelezionato', 'statoInterfacciaCambiato']);

    // VARIABILI DEL COMPONENTE
    const datiMappaLavori = ref([]);
    const datiGraficoLavori = ref([]);
    const testoRicerca = ref(props.testoDaCercare);
    const vistaMappa = ref(false);
    const mostraGraficoLavori = ref(false);
    const stringaNumeroRecord = ref("");

    // SETUP DEL COMPONENTE
    const elencoLavori = computed(()=>{
        let tempElencoLavori = [];
        if (props.cliente==null && props.elencoTassativo==null) {
            for(const cl in dbClienti.value){
                // FIX: Scudo condizionale
                if (dbClienti.value[cl] && dbClienti.value[cl].lavori) {
                    for(const ll in dbClienti.value[cl].lavori){
                        tempElencoLavori.push(dbClienti.value[cl].lavori[ll]);
                    }
                }
            }
        } else if (props.elencoTassativo!=null) {
            // E' stato passato un elenco di Lavori da visualizzare
            for(const lv in props.elencoTassativo){
                const idCl = props.elencoTassativo[lv].cliente;
                // FIX: Scudo condizionale
                if (dbClienti.value[idCl] && dbClienti.value[idCl].lavori) {
                    tempElencoLavori.push(dbClienti.value[idCl].lavori[lv]);
                }
            }
        } else {
            // FIX DEFINITIVA: Verifichiamo che il cliente (es. -1) esista in RAM prima di leggere .lavori
            if (dbClienti.value[props.cliente] && dbClienti.value[props.cliente].lavori) {
                for(const ll in dbClienti.value[props.cliente].lavori){
                    tempElencoLavori.push(dbClienti.value[props.cliente].lavori[ll]);
                }
            }
        }
        ordinaElencoLavori(tempElencoLavori);
        filtraElencoElementi(tempElencoLavori, props.testoDaCercare, props.campiDaCercare, 25);
        return tempElencoLavori;
    });

    // FUNZIONI DEL COMPONENTE
    
    function bCerca(campi) {
        emit('statoInterfacciaCambiato', {testoRicercaLavori: testoRicerca.value, campiRicercaLavori: campi});
    }

    function bSelezionaLavoro(idLv, idCl) {
        let tempIdCl;
        if (props.cliente!=null) {
            tempIdCl = props.cliente;
        } else {
            tempIdCl = idCl;
        }
        emit('elementoSelezionato', {
            tipo: 'lavoro',
            idCliente: tempIdCl,
            idLavoro: idLv
        });
    }

    function ordinaElencoLavori(elencoEl) {
        
        if (props.cliente == null) {
            elencoEl.sort((a, b) => {
                const valA = getValorePerOrdinamento(a, 'dataOrdine', false) || 0;
                const valB = getValorePerOrdinamento(b, 'dataOrdine', false) || 0;
                return valB - valA; 
            });
        } else {
            elencoEl.sort((a, b) => {
                const codA = Number(getValorePerOrdinamento(a, 'codice', false)) || 0;
                const codB = Number(getValorePerOrdinamento(b, 'codice', false)) || 0;
                return codB - codA; 
            });
        }
    }

    function filtraElencoElementi(elencoEl, testo, campi, numMax) {
        const tempStringaNumeroRecord = elencoEl.length;
        let elencoTesti = [];
        if (testo) elencoTesti = testo.split('+');
        for (let j=0; j < elencoTesti.length; j++) {
            if ( (elencoTesti[j]) && (elencoTesti[j]!="") ) {
                for (let i=0; i < elencoEl.length; i++) {
                    const regexCerca = new RegExp(elencoTesti[j], 'i');
                    let temp = null;
                    let pos = -1;
                    if ( campi[0] == 'JSON' ) {
                        temp = JSON.stringify(elencoEl[i]);
                        pos = temp.search(regexCerca);
                        if (pos==-1) {
                            if (elencoEl[i].contatti){
                                for(const ct of Object.keys(elencoEl[i].contatti)){
                                    if (dbContatti.value[ct]) {
                                        temp = JSON.stringify(dbContatti.value[ct]);
                                        pos = temp.search(regexCerca);
                                        if (pos!=-1) {
                                            break;
                                        }
                                    }
                                }
                            }
                        }
                        if (pos==-1) {
                            temp = leggiInfoDBRaw(elencoEl[i]).stringaCliente;
                            if (temp) { 
                                pos = temp.search(regexCerca);
                            }
                        }
                    } else {
                        for (const cc in campi) {
                            if (pos == -1) {
                                temp = elencoEl[i][campi[cc]];
                                pos = String(temp).search(regexCerca);
                            }
                        }
                        if (pos==-1) {
                            temp = leggiInfoDBRaw(elencoEl[i]).stringaCliente;
                            if (temp) {
                                pos = temp.search(regexCerca);
                            }
                        }
                    }
                    if (pos == -1) {
                        elencoEl.splice(i,1);
                        i--;
                    }
                }
            }
        }
        if (elencoEl.length>(numMax+5)){
            elencoEl.splice(numMax,(elencoEl.length-numMax));
        }
        stringaNumeroRecord.value = elencoEl.length + " di " + tempStringaNumeroRecord;
    }

    function bMostraGrafici() {
        let tempDati = {};
        let setTags = new Set();

        for (const cl in dbClienti.value) {
            if (!dbClienti.value[cl] || !dbClienti.value[cl].lavori) continue;

            for (const lv in dbClienti.value[cl].lavori) {
                const lavoro = dbClienti.value[cl].lavori[lv];

                // Consideriamo solo i lavori che hanno una data ordine
                if (lavoro.dataOrdine) {
                    let stringaData = dataDaTimestamp(lavoro.dataOrdine, 'testoAA-MM');
                    if (!tempDati[stringaData]) {
                        tempDati[stringaData] = { totaleLavori: 0, tags: {} };
                    }
                    
                    // Incremento conteggio globale mensile
                    tempDati[stringaData].totaleLavori += 1;

                    // Incremento conteggi per i Tag
                    if (lavoro.tags && Array.isArray(lavoro.tags)) {
                        lavoro.tags.forEach(tag => {
                            setTags.add(tag);
                            if (!tempDati[stringaData].tags[tag]) {
                                tempDati[stringaData].tags[tag] = 0;
                            }
                            tempDati[stringaData].tags[tag] += 1;
                        });
                    }
                }
            }
        }

        const arrayTags = Array.from(setTags).sort();
        datiGraficoLavori.value = [];

        // Genera la matrice
        for (const mese in tempDati) {
            let row = [mese, tempDati[mese].totaleLavori];
            arrayTags.forEach(tag => {
                row.push(tempDati[mese].tags[tag] || 0);
            });
            datiGraficoLavori.value.push(row);
        }

        // Ordina temporalmente
        datiGraficoLavori.value.sort((a, b) => {
            if (a[0] < b[0]) return -1;
            if (a[0] > b[0]) return 1;
            return 0;
        });

        // Intestazioni per GraficoVendite.vue
        datiGraficoLavori.value.unshift(['Mese', 'Totale Lavori', ...arrayTags]);

        mostraGraficoLavori.value = true;
    }

    function bComandoModale(comando) {
        if (comando == 'chiudi') {
            vistaMappa.value = false;
            mostraGraficoLavori.value = false;
        }
    }

    function bMostraMappa() {
        datiMappaLavori.value = [];
        
        let tempElencoLavori = [];
        for(const cl in dbClienti.value){
            if (dbClienti.value[cl] && dbClienti.value[cl].lavori) {
                for(const lv in dbClienti.value[cl].lavori){
                    tempElencoLavori.push(dbClienti.value[cl].lavori[lv]);
                }
            }
        }
        
        filtraElencoElementi(tempElencoLavori, props.testoDaCercare, props.campiDaCercare);

        tempElencoLavori.forEach(lavoro => {
            if (lavoro.luogo && typeof lavoro.luogo === 'string' && lavoro.luogo.includes(',')) {
                const parts = lavoro.luogo.split(',');
                if (parts.length >= 2) {
                    const lat = parseFloat(parts[0].trim());
                    const lng = parseFloat(parts[1].trim());

                    if (!isNaN(lat) && !isNaN(lng)) {
                        let titolo = lavoro.oggetto || lavoro.tipo || 'Lavoro senza oggetto';
                        
                        const info = leggiInfoDBRaw(lavoro);
                        if (info && info.stringaCliente) {
                            titolo = info.stringaCliente + " - " + titolo;
                        }

                        let colorePin;
                        switch (lavoro.tipo) {
                            case 'Impianto fotovoltaico':
                                colorePin = 'giallo';
                                break;
                            case 'Condizionatore':
                                colorePin = 'azzurro';
                                break;
                            case 'Caldaia a gas':
                                colorePin = 'arancione';
                                break;
                            default:
                                colorePin = 'rosso';
                                break;
                        }
                        datiMappaLavori.value.push({
                            lat: lat,
                            lng: lng,
                            titolo: titolo,
                            colore: colorePin,
                            payload: {
                                tipo: 'lavoro',
                                idLavoro: info.id,
                                idCliente: info.idCliente
                            }
                        });
                    }
                }
            }
        });

        vistaMappa.value = true;
    }

</script>